import React, { Component } from "react";
import { Sidebarc } from "../src/Sidebar";
import { Appheaderc } from "./Appheader";
import { Button, Paper, Typography } from "@mui/material";
import { Box, Backdrop, CircularProgress } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DriveFileMoveIcon from "@mui/icons-material/DriveFileMove";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import moment from "moment"
import InfoIcon from '@mui/icons-material/Info';
// import SearchIcon from '@mui/icons-material/Search';
import rr from '../src/img/rr.png'

import {
  Tooltip,
  IconButton,
  TableBody,
  Table,
  Modal,
  MenuItem,
  TableContainer,
  TablePagination,
  Divider,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  InputAdornment,
} from "@mui/material";
import base_url from "./baseurl";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
const drawerWidth = 240;

class OrderList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: "",
      email: "",
      phone_no: "",
      password: "", 


      id: "",
  

      orderList: [],

      page: 0,
      rowsPerPage: 10,
      counts: 0,


      search_name : ""
    };
    this.handleChange = this.handleChange.bind(this);
  }


  
  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };



  searchEmailCust = (e) => {
    this.setState({ [e.target.name]: e.target.value },()=>{
      this.instantRetrive()
    });
  };


  componentDidMount() {
    fetch(`${base_url.base_url}/order/retriveOrderList`, {
      headers: {
        "content-type": "application/json",
      },
      method: "post",
      body: JSON.stringify({
        rowsPerPage: 10,
        page: 0,
        search_name  :this.state.search_name
      }),
    })
      .then((res) => {
        return res.json();
      })
      .then((result) => {
        this.setState({ orderList: result.data, counts: result.size });
      });
  }




  instantRetrive=()=>{
    fetch(`${base_url.base_url}/order/retriveOrderList`, {
      headers: {
        "content-type": "application/json",
      },
      method: "post",
      body: JSON.stringify({
        rowsPerPage: 10,
        page: 0,
        search_name  :this.state.search_name
      }),
    })
      .then((res) => {
        return res.json();
      })
      .then((result) => {
        this.setState({ orderList: result.data, counts: result.size });
      });
  }







  updated = () => {
    toast.info(
      <Typography sx={{ fontSize: 13, fontWeight: "bold" }}>
        Order Staus Updated
      </Typography>,
      {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        draggable: true,
        progress: undefined,
        icon: "🚀",
        theme: "colored",
      }
    );
  };



  delete = () => {
    toast.info(
      <Typography sx={{ fontSize: 13, fontWeight: "bold" }}>
        Order deleted{" "}
      </Typography>,
      {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        draggable: true,
        progress: undefined,
        icon: "🚀",
        theme: "colored",
      }
    );
  };



  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage }, () => {
      this.instantRetrive()
    });
  };



  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: parseInt(event.target.value, 10) });
    this.setState({ page: 0 }, () => {
      this.instantRetrive()
    })
  };


  render() {
    return (
      <div>
        <Box sx={{ display: "flex" }}>
          <Sidebarc />
          <Box
            sx={{ width: { sm: `calc(100% - ${drawerWidth}px)`, xs: "100%" } }}
          >
            <Box sx={{ p: { xs: 1, sm: 3 }, mt: 6 }}>
              <Typography
                style={{
                  fontWeight: "bold",
                  color: "black",
                  fontSize: 16,
                  marginTop: 5,
                  marginBottom: 5,
                  marginLeft: 10,
                }}
              >
                Order List
              </Typography>

              <Paper
                elevation={0}
                sx={{
                  height: 50,
                  width: "100%",
                  backgroundColor: "#fff",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "left",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: 17,
                      fontWeight: "500",
                      paddingLeft: { xs: 1, sm: 2, md: 3 },
                      color: "#666666",
                    }}
                  >
                    Order List
                  </Typography>
                </Box>
              </Paper>

              <Paper elevation={0} sx={{ width: "100%", minHeight: 200, mt: 2 }}>
                
                <Box sx={{ mt: 0, padding: 2}}>

                <TextField size="small" sx={{width:230,mb:1}} placeholder="Search Customer Email" onChange={this.searchEmailCust} name='search_name' InputProps={{sx:{fontSize:12}}}/>

                  <TableContainer component={Box}>
                    <Table
                      sx={{ minWidth: 920 }}
                      size="small"
                      aria-label="a dense table"
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell
                            align="left"
                            sx={{
                              fontSize: 12,
                              fontWeight: "500",
                              color: "#1b7bce",
                            }}
                          >
                            ORDER ID
                          </TableCell>
                          <TableCell
                            align="left"
                            sx={{
                              fontSize: 12,
                              fontWeight: "500",
                              color: "#1b7bce",
                            }}
                          >
                            ORDER DATE
                          </TableCell>
                            
                          <TableCell
                            align="left"
                            sx={{
                              fontSize: 12,
                              fontWeight: "500",
                              color: "#1b7bce",
                            }}
                          >
                            DELIVERY DATE
                          </TableCell>
                          <TableCell
                            align="left"
                            sx={{
                              fontSize: 12,
                              fontWeight: "500",
                              color: "#1b7bce",
                            }}
                          >
                            CUSTOMER EMAIL
                          </TableCell>
                          <TableCell
                            align="left"
                            sx={{
                              fontSize: 12,
                              fontWeight: "500",
                              color: "#1b7bce",
                            }}
                          >
                            STATUS
                          </TableCell>
                      
                          <TableCell
                            align="right"
                            sx={{
                              fontSize: 12,
                              fontWeight: "500",
                              color: "#1b7bce",
                            }}
                          >
                            ACTION
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {this.state.orderList.map((row,i) => (
                          <TableRow
                            key={row._id}
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 },backgroundColor:i%2?'#f4f4f4':'#fff'
                            }}
                          >
                            <TableCell
                              component="th"
                              scope="row"
                              sx={{ color: "#42526e", fontSize: 13 }}
                            >
                              <Button
                                variant="contained"
                                disableElevation
                                style={{
                                  height: 20,
                                  fontSize: 11,
                                  fontWeight: "600",
                                  color: "#fff",
                                }}
                              >
                                {row.order_id}
                              </Button>
                            </TableCell>
                        
                            <TableCell align="left" sx={{ color: "#42526e",fontSize:12 }}>
                             {moment(row.order_date).format('DD-MM-YYYY') }
                            </TableCell>  
                            
                            <TableCell align="left" sx={{ color: "#42526e",fontSize:12 }}>
                                {moment(row.created_at).format('YYYY-MM-DD')}
                            </TableCell>
                            <TableCell align="left" sx={{ color: "#42526e" ,fontSize:12}}>
                             {row.cust_email}
                            </TableCell>
                             <TableCell align="left" sx={{ color: "#42526e" ,fontSize:12}}>
                            <TextField
          id="outlined-select-currency"
          select
          sx={{fontSize:12}}
          InputProps={{style:{fontSize:12,fontWeight:600}}}
          defaultValue={row.status}
          size="small"
        >
          {[{id:1,name:'Pending'},{id:2,name:'Approved'},{id:3,name:'Cancel'},{id:4,name:'Delivered'}].map((option) => (
            <MenuItem key={option.name} value={option.name} sx={{fontSize:12,fontWeight:'600'}} onClick={()=>{
              fetch(`${base_url.base_url}/order/updateStatus`, {
                headers: {
                  "content-type": "application/json",
                },
                method: "put",
                body: JSON.stringify({
                  order_id : row.order_id,
                  status : option.name
                }),
              })
                .then((res) => {
                  return res.json();
                })
                .then((result) => {
                 this.instantRetrive()
                 this.updated()
                });
            }}>
              {option.name}
            </MenuItem>
          ))}
        </TextField>
                            </TableCell>
                            <TableCell align="right">
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "right",
                                }}
                              >


                                <Tooltip title="More Details">
                                  <IconButton
                                    size="small"
                                    onClick={()=>this.props.navigate(`/orderDescription/:${row.order_id}`)}
                                  >
                                    <ArrowForwardIcon
                                      sx={{
                                        color: "#4d95dc",
                                        height: 15,
                                        width: 15,
                                      }}
                                    />
                                  </IconButton>
                                </Tooltip>


                                <Tooltip title="Delete">
                                  <IconButton
                                    onClick={() => {
                                      if (window.confirm("Do you really want to delete?")) {
                                      
                                        fetch(
                                          `${base_url.base_url}/order/deleteOrder`,
                                          {
                                            headers: {
                                              "content-type": "application/json",
                                            },
                                            method: "delete",
                                            body: JSON.stringify({
                                              id: row._id,
                                            }),
                                          }
                                        )
                                          .then((res) => {
                                            return res.json();
                                          })
                                          .then((result) => {
                                           this.instantRetrive();
                                           this.delete()
                                          })
  
                                        
                                      

                                      }
                                    }}
                                    size="small"
                                  >
                                    <DeleteForeverIcon
                                      sx={{
                                        color: "#f29494",
                                        height: 15,
                                        width: 15,
                                      }}
                                    />
                                  </IconButton>
                                </Tooltip>
                              </Box>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>

                  <Divider />
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={this.state.counts}
                    rowsPerPage={this.state.rowsPerPage}
                    page={this.state.page}
                    onPageChange={this.handleChangePage}
                    onRowsPerPageChange={this.handleChangeRowsPerPage}
                  />




                </Box>

<Box sx={{height:200,width:'100%',display: 'none',justifyContent:'center',alignItems:'center'}}>
<img src={rr} style={{height:200,width:'100%',objectFit:'contain'}}/>
</Box>
              </Paper>
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              position: "fixed",
              top: 0,
              left: { xs: 0, sm: 240 },
            }}
          >
            <Appheaderc />
          </Box>
        </Box>

 

        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </div>
    );
  }
}

export default OrderList;


export function OrderListc(props){
  const navigate = useNavigate();
  const location = useLocation();
  const param = useParams();
  return (<OrderList param={param}  location={location} navigate={navigate}></OrderList>)
}


